import React from 'react';
import './Terms.css';
import BackButton from './backbutton/BackButton';

const Terms = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <BackButton />
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Clubsta ("the Service"), you agree to comply with and be bound by 
            these Terms and Conditions and our Privacy Policy. If you do not agree to these terms, 
            you may not use the Service.
          </p>
        </section>

        <section>
          <h2>2. Eligibility</h2>
          <p>
            Clubsta is intended for use only by individuals who are 18 years of age or older. 
            By using the Service, you confirm that you are at least 18 years old.
          </p>
        </section>

        <section>
          <h2>3. Description of Service</h2>
          <p>
            Clubsta is a directory platform designed to help users discover and connect with local 
            running clubs. The Service provides club information, run schedules, organizer details, 
            and community-driven insights to support in-person running events and social engagement.
          </p>
        </section>

        <section>
          <h2>4. User Responsibilities</h2>
          <p>Users of Clubsta agree to:</p>
          <ul>
            <li>Provide accurate, non-misleading information when submitting or editing club listings</li>
            <li>Use the Service only for lawful purposes and in accordance with these Terms</li>
            <li>Respect the privacy, safety, and rights of other users and organizers</li>
            <li>Refrain from tampering with, disrupting, or compromising the integrity of the Service</li>
          </ul>
        </section>

        <section>
          <h2>5. Club Submissions and Public Content</h2>
          <p>
            When you submit club information or content to Clubsta, you grant us a non-exclusive, 
            royalty-free license to display, modify, and distribute the content for the purpose of 
            making it available to other users. Submitted club listings are publicly accessible.
          </p>
        </section>

        <section>
          <h2>6. Accuracy and Availability</h2>
          <p>
            While we strive to provide up-to-date and reliable club information, we do not guarantee 
            the accuracy, completeness, or ongoing availability of any listings or event details. 
            Users are encouraged to confirm specifics directly with the club.
          </p>
        </section>

        <section>
          <h2>7. Third-Party Services</h2>
          <p>
            Clubsta may include links or embedded elements from third-party services, such as maps 
            or social media feeds. We are not responsible for the content or practices of these 
            external services. Interactions with third-party features are subject to their own 
            terms and policies.
          </p>
        </section>

        <section>
          <h2>8. Privacy</h2>
          <p>
            We take privacy seriously. Our collection, use, and sharing of data—including any 
            personal or usage information—is governed by our <strong>Privacy Policy</strong>, which 
            is incorporated into these Terms by reference.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Clubsta shall not be liable for any indirect, 
            incidental, consequential, special, or exemplary damages, including loss of profits, 
            data, goodwill, or other intangible losses, arising from your use or inability to use 
            the Service.
          </p>
        </section>

        <section>
          <h2>10. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Clubsta, its affiliates, and team members from 
            any claims, damages, or liabilities arising out of your use of the Service, your violation 
            of these Terms, or your infringement of any rights of another party.
          </p>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access to Clubsta at any time, without 
            notice or liability, if we believe you have violated these Terms or acted in a way that 
            could harm the platform or its users.
          </p>
        </section>

        <section>
          <h2>12. Changes to Terms</h2>
          <p>
            We may update these Terms periodically to reflect changes in our services or policies. 
            Material changes will be communicated via the website. Continued use of Clubsta 
            constitutes acceptance of the revised Terms.
          </p>
        </section>

        <section>
          <h2>13. Governing Law</h2>
          <p>
            These Terms and any disputes related to them shall be governed by and construed in 
            accordance with the laws of the State of California, without regard to conflict of law principles.
          </p>
        </section>

        <section>
          <h2>14. Contact Information</h2>
          <p>
            If you have any questions or concerns about these Terms and Conditions, please contact us at:
          </p>
          <p>
            Email: luke.furnell@clubsta.co<br />
            Website: www.clubsta.co
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
